import React from "react";
import PropTypes from "prop-types";

import FullwidthCard from "../FullwidthCard";

import Image from "./Image";
import Header from "./Header";

// Owned-merch card. Deliberately has NO content/footer action — unlike TicketCard
// it must not carry the "send ticket" transfer (TicketDistributionService), which
// reassigns ownership. Merch is collected by the buyer, never transferred.
const MerchCard = ({ item }) => {

  const { title, variant_label, description, uuid, event, redeem_state, completed_at } = item;
  const collected = redeem_state === 'completed';

  return (
    <FullwidthCard image={<Image reference={uuid} />}
                   header={<Header event_title={event?.title} start_date={event?.start_date} title={title} variant_label={variant_label} description={description}
                                   collected={collected} collected_at={completed_at} />} />
  );
};

MerchCard.propTypes = {
  item: PropTypes.object,
};

export default MerchCard;
